import { EXPORT_PROJECTIONS_TYPES } from 'modules/core/components/DataTable/constants'
import i18n from 'modules/core/lib/i18n'

export const expensesExportProjections = () => {
  return [
    {
      path: 'date',
      title: i18n.t('project_management.export.date'),
    },
    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectOwners',
      title: i18n.t('project_management.export.project_owners'),
    },
    {
      path: 'subprojectName',
      title: i18n.t('project_management.export.subproject_name'),
    },
    {
      path: 'employeeName',
      title: i18n.t('project_management.export.employee_name'),
    },
    {
      path: 'employee_companyIdentifier',
      title: i18n.t('project_management.export.company_identifier'),
    },
    {
      path: 'preferredName',
      title: i18n.t('project_management.export.preferred_name'),
    },
    {
      path: 'amount',
      title: i18n.t('project_management.export.amount'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    },
    {
      path: 'currency',
      title: i18n.t('project_management.export.currency'),
    },
    {
      path: 'expenseCategory',
      title: i18n.t('project_management.export.expense_category'),
    },
    {
      path: 'expenseSubcategory',
      title: i18n.t('project_management.export.expense_subcategory'),
    },
    {
      path: 'expenseStatus',
      title: i18n.t('project_management.export.expense_status'),
    },
    {
      path: 'expenseLink',
      title: i18n.t('project_management.export.expense_link'),
    },
  ]
}

interface IExportProjection {
  path: string
  title: string
  type?: string
}

export const totalTimeExportProjections = (
  byDate: boolean,
  hasSubprojects: boolean,
  decimal: boolean,
  hasClients: boolean,
  showCost: boolean
) => {
  let projections: IExportProjection[] = []

  if (byDate) {
    projections.push({
      path: 'date',
      title: i18n.t('project_management.export.date'),
    })
  }

  projections = projections.concat([
    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectDescription',
      title: i18n.t('project_management.export.project_description'),
    },
    {
      path: 'projectOwners',
      title: i18n.t('project_management.export.project_owners'),
    },
    {
      path: 'projectStartDate',
      title: i18n.t('project_management.export.project_start_date'),
    },
    {
      path: 'projectDueDate',
      title: i18n.t('project_management.export.project_due_date'),
    },
    {
      path: 'projectStatus',
      title: i18n.t('project_management.export.project_status'),
    },
  ])

  if (hasSubprojects) {
    projections.push({
      path: 'subprojectName',
      title: i18n.t('project_management.export.subproject_name'),
    })
  }

  if (hasClients) {
    projections.push({
      path: 'client_legalName',
      title: i18n.t('project_management.export.client_legal_name'),
    })
  }

  projections.push({
    path: 'employeeName',
    title: i18n.t('project_management.export.employee_name'),
  })
  projections.push({
    path: 'employee_companyIdentifier',
    title: i18n.t('project_management.export.company_identifier'),
  })
  projections.push({
    path: 'inputedTime',
    title: i18n.t('project_management.export.imputed_hours'),
    type: decimal ? EXPORT_PROJECTIONS_TYPES.FLOAT : EXPORT_PROJECTIONS_TYPES.STRING,
  })

  if (showCost) {
    projections.push({
      path: 'cost',
      title: i18n.t('project_management.export.cost'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    })
  }

  return projections
}

export const totalTimeByEmployeeProjections = (hasSubprojects: boolean, decimal: boolean) => {
  const projections: IExportProjection[] = [
    {
      path: 'employeeName',
      title: i18n.t('project_management.export.employee_name'),
    },
    {
      path: 'employee_companyIdentifier',
      title: i18n.t('project_management.export.company_identifier'),
    },
    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectOwners',
      title: i18n.t('project_management.export.project_owners'),
    },
    {
      path: 'projectStatus',
      title: i18n.t('project_management.export.project_status'),
    },
  ]

  if (hasSubprojects) {
    projections.push({
      path: 'subprojectName',
      title: i18n.t('project_management.export.subproject_name'),
    })
  }

  projections.push({
    path: 'duration',
    title: i18n.t('project_management.export.imputed_hours'),
    type: decimal ? EXPORT_PROJECTIONS_TYPES.FLOAT : EXPORT_PROJECTIONS_TYPES.STRING,
  })

  return projections
}

export const shiftsExportProjections = (hasSubprojects: boolean, decimal: boolean) => {
  const projections = [
    {
      path: 'employeeName',
      title: i18n.t('project_management.export.employee_name'),
    },
    {
      path: 'employee_companyIdentifier',
      title: i18n.t('project_management.export.company_identifier'),
    },
    {
      path: 'date',
      title: i18n.t('project_management.export.date'),
    },
    {
      path: 'clockIn',
      title: i18n.t('project_management.export.clock_in'),
    },
    {
      path: 'clockOut',
      title: i18n.t('project_management.export.clock_out'),
    },
    {
      path: 'duration',
      title: i18n.t('project_management.export.duration'),
      type: decimal ? EXPORT_PROJECTIONS_TYPES.FLOAT : EXPORT_PROJECTIONS_TYPES.STRING,
    },
    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectOwners',
      title: i18n.t('project_management.export.project_owners'),
    },
  ]
  if (hasSubprojects) {
    projections.push({
      path: 'subprojectName',
      title: i18n.t('project_management.export.subproject_name'),
    })
  }

  projections.push({
    path: 'comments',
    title: i18n.t('project_management.export.comments'),
  })
  return projections
}

export const tasksExportProjections = (hasSubprojects: boolean) => {
  const projections = [
    {
      path: 'taskName',
      title: i18n.t('project_management.export.tasks.task'),
    },

    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectDescription',
      title: i18n.t('project_management.export.project_description'),
    },
    ...(hasSubprojects
      ? [
          {
            path: 'subprojectName',
            title: i18n.t('project_management.export.subproject_name'),
          },
        ]
      : []),
    {
      path: 'assignees',
      title: i18n.t('project_management.export.tasks.assigned_to'),
    },
    {
      path: 'employeesCompanyIdentifiers',
      title: i18n.t('project_management.export.tasks.employee_company_identifier'),
    },
    {
      path: 'taskStatus',
      title: i18n.t('project_management.export.tasks.status'),
    },
    {
      path: 'taskStartsOnDate',
      title: i18n.t('project_management.export.tasks.start_date'),
    },
    {
      path: 'taskDueOnDate',
      title: i18n.t('project_management.export.tasks.deadline'),
    },
    {
      path: 'daysUntilDeadline',
      title: i18n.t('project_management.export.tasks.days_until_deadline'),
    },
    {
      path: 'daysBetweenInProgressAndDone',
      title: i18n.t('project_management.export.tasks.days_between_in_progress_and_done'),
    },
  ]

  return projections
}

export const costAndBillRateByEmployeeProjections = (hasSubprojects: boolean, decimal: boolean) => {
  const projections: IExportProjection[] = [
    {
      path: 'date',
      title: i18n.t('project_management.export.date'),
    },
    {
      path: 'projectName',
      title: i18n.t('project_management.export.project_name'),
    },
    {
      path: 'projectCode',
      title: i18n.t('project_management.export.project_code'),
    },
    {
      path: 'projectStatus',
      title: i18n.t('project_management.export.project_status'),
    },
  ]

  if (hasSubprojects) {
    projections.push({
      path: 'subprojectName',
      title: i18n.t('project_management.export.subproject_name'),
    })
  }

  projections.push(
    {
      path: 'employeeName',
      title: i18n.t('project_management.export.employee_name'),
    },
    {
      path: 'inputedTime',
      title: i18n.t('project_management.export.imputed_hours'),
      type: decimal ? EXPORT_PROJECTIONS_TYPES.FLOAT : EXPORT_PROJECTIONS_TYPES.STRING,
    },
    {
      path: 'costRate',
      title: i18n.t('project_management.export.cost_rate'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    },
    {
      path: 'costTotal',
      title: i18n.t('project_management.export.cost_total'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    },
    {
      path: 'billRate',
      title: i18n.t('project_management.export.bill_rate'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    },
    {
      path: 'billTotal',
      title: i18n.t('project_management.export.bill_total'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    },
    {
      path: 'profitabilityPercentage',
      title: i18n.t('project_management.export.profitability_percentage'),
      type: EXPORT_PROJECTIONS_TYPES.FLOAT,
    }
  )

  return projections
}
